import React from "react";
import {
	Form,
	Divider,
	Loader,
	Label,
	Input,
	Button,
	Icon,
	Message
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { change, checkMid, save } from "../../modules/mainbase.js";

const BAGForm = props => {
	return props.state !== "on" ? (
		<Form>
			<Divider horizontal>BAG-Daten</Divider>
			<Form.Input
				icon="road"
				value={props.contract}
				onChange={x => props.change("contract", x.target.value)}
				label="BAG-Kontraktnummer"
				type="text"
			/>
			<Form.Input
				icon="point"
				value={props.plant}
				onChange={x => props.change("plant", x.target.value)}
				label="BAG-Werksnummer"
				type="text"
			/>

			<Divider horizontal>BPO-Daten</Divider>
			{props.loader === "waiting" ? (
				<Loader indeterminate active inline="centered">
					Warte auf Eingabe
				</Loader>
			) : (
				<div />
			)}
			{props.loader === "loading" ? (
				<Loader active inline="centered">
					Suche nach vorhandenen Einträgen
				</Loader>
			) : (
				<div />
			)}
			{props.loader === "hidden" ? (
				<div>
					<Form.Field>
						<label>BPO-Schnittstellencode</label>
						<Input
							icon="cloud"
							loading={props.midstatus === "loading"}
							value={props.mid}
							onChange={x => props.change("mid", x.target.value)}
							type="text"
						/>
						{props.midstatus !== "empty" &&
						props.midstatus !== "loading" &&
						props.midstatus !== "ok" ? (
							<Label
								basic
								color={
									props.midstatus === "error"
										? "red"
										: "yellow"
								}
								pointing
							>
								{props.midstatus === "error"
									? "Der eingegebene Code ist fehlerhaft."
									: "Fehler beim Prüfen des Codes."}
							</Label>
						) : (
							<div />
						)}
					</Form.Field>
					{props.midstatus === "missing" ? (
						<Button
							fluid
							color="yellow"
							onClick={() => props.checkMid()}
						>
							<Icon name="refresh" />Code erneut prüfen
						</Button>
					) : (
						<div />
					)}
					{props.midstatus === "ok" ? (
						<div>
							<Button
								fluid
								color="green"
								loading={props.state === "saving"}
								onClick={() =>
									props.state === "saving"
										? ""
										: props.save()}
							>
								<Icon name="check" />Speichern
							</Button>
							{props.state === "error" ? (
								<Label basic color="red" pointing>
									Fehler beim Speichern. Bitte erneut
									versuchen.
								</Label>
							) : (
								<div />
							)}
						</div>
					) : (
						<div />
					)}
				</div>
			) : (
				<div />
			)}
		</Form>
	) : (
		<Message
			positive
			icon="check"
			header="Schnittstellendaten erfolgreich erfasst"
			content="Die Daten wurden erfolgreich erfasst. Die Schnittstelle ist nun einsatzbereit."
		/>
	);
};

const mapStateToProps = (state, props) => ({
	contract: state.mainbase.contract,
	plant: state.mainbase.plant,
	mid: state.mainbase.mid,
	midstatus: state.mainbase.midstatus,
	loader: state.mainbase.loader,
	state: state.mainbase.state
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			change,
			checkMid,
			save
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(BAGForm);



// WEBPACK FOOTER //
// ./src/containers/app/bag.js